module.exports = __webpack_public_path__ + "img/b_3.85c6d949.png";